import { useState, useEffect } from "react";
import { Link } from "react-router";
import { Heart } from "lucide-react";
import { useShopProducts } from "@/lib/api.ts";
import { getWishlist } from "@/lib/wishlist.ts";
import { ProductCard } from "@/components/ProductCard.tsx";
import { useDocumentHead } from "@/hooks/useDocumentHead.ts";

export function WishlistPage() {
  useDocumentHead({
    title: "My Wishlist",
    description: "Your saved products at The Secret Trends. Keep track of items you love.",
  });
  const [wishlistIds, setWishlistIds] = useState(() => getWishlist());
  const { data } = useShopProducts();

  useEffect(() => {
    const handler = () => setWishlistIds(getWishlist());
    window.addEventListener("wishlist-change", handler);
    return () => window.removeEventListener("wishlist-change", handler);
  }, []);

  const allProducts = data ? Object.values(data).flat() : [];
  const wishlistProducts = allProducts.filter((p) =>
    wishlistIds.includes(p.id)
  );

  return (
    <div className="mx-auto max-w-[1360px] px-6 py-20 lg:px-10">
      <h1 className="mb-2 text-[32px] font-medium tracking-tight text-heading">
        Your Wishlist
      </h1>
      <p className="mb-12 text-sm text-text-muted">
        {wishlistProducts.length}{" "}
        {wishlistProducts.length === 1 ? "item" : "items"} saved
      </p>

      {wishlistProducts.length > 0 ? (
        <div className="grid grid-cols-2 gap-6 lg:grid-cols-4 lg:gap-8">
          {wishlistProducts.map((p) => (
            <ProductCard key={p.id} product={p} />
          ))}
        </div>
      ) : (
        <div className="flex flex-col items-center py-24 text-center">
          <Heart size={48} className="mb-4 text-border" />
          <p className="mb-2 text-lg font-medium text-heading">
            Your wishlist is empty
          </p>
          <p className="mb-8 text-sm text-text-muted">
            Save items you love by tapping the heart icon.
          </p>
          <Link
            to="/"
            className="bg-[#1A1A1A] px-8 py-3 text-sm font-medium tracking-wide text-white transition-colors hover:bg-[#333]"
          >
            Continue Shopping
          </Link>
        </div>
      )}
    </div>
  );
}
